import type { CategoryDetailsSchema } from '~/types/product.model'

export const PAGE_TYPES = {
  mainPage: 'main_page',
  allApps: 'all_apps',
  category: 'category',
}

export const FAKE_CATEGORY_SLUGS = { allApps: 'all-apps' }
export const CATEGORY_FILTER_ID = 'category'

export const BASE_SITE_TITLE = 'Sendcloud App Store'
export const MAIN_PAGE_TITLE = 'Essential E-commerce Apps'
export const DEFAULT_ALL_APPS_TITLE = 'All Apps'
export const META_ALL_APPS_TITLE = 'All E-commerce Apps'
export const META_ALL_APPS_DESCRIPTION =
  'Connect to 100+ shipping apps, WMS, ERP, and more. Discover the best e-commerce apps to build your ideal shipping experience today.'

export const getAllAppsCategoryData = (
  override: Partial<CategoryDetailsSchema> = {},
): CategoryDetailsSchema => ({
  slug: FAKE_CATEGORY_SLUGS.allApps,
  title: DEFAULT_ALL_APPS_TITLE,
  app_count: 0,
  description:
    'Browse through the best e-commerce apps. Discover new apps, connect to your favorites, and build your ideal shipping experience.',
  seo_meta_title: META_ALL_APPS_TITLE,
  seo_meta_description: META_ALL_APPS_DESCRIPTION,
  ...override,
})

export const getFullPageTitle = (subtitle?: string): string =>
  subtitle ? `${subtitle} | ${BASE_SITE_TITLE}` : BASE_SITE_TITLE

export const APP_TABS_DATA = {
  overview: { id: 'overview', title: 'Overview' },
  howToConnect: { id: 'how-to-connect', title: 'How to connect' },
  resourcesAndSupport: {
    id: 'resources-and-support',
    title: 'Resources & Support',
  },
  privacyAndTerms: { id: 'privacy-and-terms', title: 'Privacy & Terms' },
  carrierLinks: { id: 'carrier-links', title: 'Carrier links' },
  reviews: { id: 'reviews', title: 'Reviews' },
} as const

export type AppTabsData = typeof APP_TABS_DATA
export type AppDetailsTabTitle = AppTabsData[keyof AppTabsData]['title']

export const BUSINESS_TYPE_MAP = {
  ANIMALS_PETS: 'Animals & Pets',
  BABY_TODDLER: 'Baby & Toddler',
  CAR_MOTOR: 'Car & Motor',
  CLOTHING_FASHION: 'Clothing & Fashion',
  EDUCATION_BOOKS: 'Education & Books',
  ELECTRONICS: 'Electronics',
  FOODS_DRINKS: 'Foods & Drinks',
  FULFILMENT: 'Fulfilment',
  FURNITURE_DECORATION: 'Furniture & Decoration',
  HEALTH_BEAUTY: 'Health & Beauty',
  HOME_GARDEN_DIY: 'Home, Garden, DIY',
  JEWELRY_ACCESSORIES: 'Jewelry & Accessories',
  LOGISTICS_SERVICE_PROVIDER: 'Logistics Service Provider',
  MARKETPLACE: 'Marketplace',
  OFFICE_SUPPLIES: 'Office Supplies',
  OTHER: 'Other',
  SPORTS_RECREATION: 'Sports & Recreation',
  TOYS_GAMES_ENTERTAINMENT: 'Toys & Games, Entertainment',
} as const

export const APP_LIST_CONTAINER_TELEPORT_ID = 'app-categories-header'

/**
 * Redeclaring large breakpoint value from `_responsiveness.scss` for using it within Javascript.
 * Alternatively, we could expose breakpoints via JSON and import it in SASS (but failed within available time).
 * Variable is used in `Sorting.vue` to toggle between pills (mobile) & dropdown (desktop) style sorting options.
 */
export const BREAKPOINT_MD = 768
export const BREAKPOINT_LG = 1024
